import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {News, Module} from '../../models/models';
import {Translation} from '../../models/translation';
import {UserService} from '../../services/user.service';
import {NewsService} from '../../services/news.service';
import {ModuleService} from '../../services/module.service';
import {LoginService} from '../../services/login.service';
import {TranslationService} from '../../services/translation.service';
import {WheelNewsOrderService} from '../../services/wheelNewsOrder.service';
import {ChangePasswordService} from '../../services/change-password.service';
import {MaintenanceService} from '../../services/maintenance.service';
import {Location} from '@angular/common';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-home',
  styleUrls: ['./home.component.css'],
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {

  constructor(
    private router: Router,
    private loginService: LoginService,
    private moduleService: ModuleService,
    private userService: UserService,
    private changePasswordService: ChangePasswordService,
    private newsService: NewsService,
    private wheelNewsOrderService: WheelNewsOrderService,
    private maintenanceService: MaintenanceService,
    private route: ActivatedRoute,
    private translationService: TranslationService,
    private location: Location
  ) { }

  public modules: Module[];
  public news: News[] = [];
  public translation: Translation;
  public language: string;
  public tempPw1: string;
  public tempPw2: string;

  public toast = Swal.mixin({toast: true, position: 'top-right', timer: 2000, timerProgressBar: false, showConfirmButton: false});

  ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.translation = JSON.parse(localStorage.getItem('Translation'));
    this.language = localStorage.getItem('Language');

    // Process QueryParams
    this.route.queryParams.subscribe(params => {
      switch (params.message) {
        case '0': Swal.fire(this.translation.Warning, this.translation.YouHaveNoRightToDoThat, 'warning'); break;
        case '1': Swal.fire(this.translation.Success, this.translation.TransportSuccessMessage, 'success'); break;
        case '2': Swal.fire(this.translation.Error, this.translation.NoAssignedAddressMessage, 'error'); break;
        case '3': this.wheelNewsSuccessMessage(params.ids); break;
        case '4': Swal.fire(this.translation.Error, this.translation.NoRightsForStatusCheckMessage, 'error'); break;
        case '5': Swal.fire(this.translation.Success, this.translation.TransportSuccessMessage, 'success'); break;
      }
      this.location.replaceState('home');
    });
    this.loadModules();
    this.loadNews();
    this.firstLogin();
    this.termsAndConditionsRead();
    this.maintenanceService.checkMaintenance().subscribe(response1 => {
      if (response1.Ok) {
        if (response1.Obj) {
          this.maintenanceService.getMaintenanceDateTime().subscribe(response2 => {
            if (response2.Ok) {
              sessionStorage.setItem('Maintenance', 'true');
              sessionStorage.setItem('MaintenanceDate', response2.Obj[0]);
              sessionStorage.setItem('MaintenanceTime', response2.Obj[1]);
            } else if (response2.Msg === 'Internal Server Error') { console.log(response2.Ex); }
            if (response2.Msg) { this.toast.fire({title: response2.Msg, icon: response2.Ok ? 'success' : 'error'}); }
          }, error => { this.toast.fire(this.translation.InternalServerError); });
        }
      } else if (response1.Msg === 'Internal Server Error') { console.log(response1.Ex); }
      if (response1.Msg) { this.toast.fire({title: response1.Msg, icon: response1.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  wheelNewsSuccessMessage(orderIds: string[]) {
    const parsedOrderIds: number[] = [];
    orderIds.forEach(id => { parsedOrderIds.push(+id); });
    Swal.fire({
      title: this.translation.Success,
      text: this.translation.WheelNewsOrderSuccessMessage,
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: this.translation.ShowDeliverySlips,
      cancelButtonText: this.translation.Close,
      confirmButtonColor: '#CC0000'
    }).then((result) => {
      if (result.isConfirmed) { this.generatePdfs(parsedOrderIds); }
    });
  }

  generatePdfs(orderIds: number[]) {
    this.wheelNewsOrderService.generatePdfByOrderIds(orderIds).subscribe(response => {
      if (response.Ok) {
        const binaryString = window.atob(response.Obj.toString());
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; ++i) { bytes[i] = binaryString.charCodeAt(i); }
        window.open(URL.createObjectURL(new Blob([bytes], {type: 'application/pdf'})), '_blank');
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  navigate(forwardLink: string) {
    if (forwardLink !== '') { this.router.navigate([forwardLink]); }
  }

  loadModules() {
    let modules: Module[] = [];
    if (JSON.parse(sessionStorage.getItem('Modules')).length !== 0) {
      for (const module of JSON.parse(sessionStorage.getItem('Modules'))) {
        switch (module.ModuleId) {
          case 10:
          case 11:
            module.ModuleName = this.translation.Transport;
            module.ModuleDesc = this.translation.TransportDesc;
            break;
          case 20:
          case 21:
            module.ModuleName = this.translation.WheelNews;
            module.ModuleDesc = this.translation.WheelNewsDesc;
            break;
          case 40:
            module.ModuleName = this.translation.AirportParking;
            module.ModuleDesc = this.translation.AirportParkingDesc;
            break;
          case 55:
            module.ModuleName = this.translation.VehicleLogistics;
            module.ModuleDesc = this.translation.VehicleLogisticsDesc;
            break;
          case 60:
            module.ModuleName = 'Schadenverwaltung';
            module.ModuleDesc = 'Cotrainterne Schadenverwaltung';
            break;
          case 80:
            module.ModuleName = this.translation.StatusCheck;
            module.ModuleDesc = this.translation.StatusCheckDesc;
            break;
          case 70:
            continue;
        }
        module.ModuleButtonText = this.translation.Next;
        modules.push(module);
      }

      modules.sort((a, b) => (a.ModuleId < b.ModuleId ? -1 : 1));
      modules = modules.filter(m => m.ModuleId !== 70);
      this.modules = modules;
    } else {
      Swal.fire(this.translation.Error, this.translation.NoAssignedModulesMessage, 'error');
      sessionStorage.clear();
      this.router.navigate(['/login']).then(r => r);
    }
  }

  loadNews() {
    this.newsService.getNews().subscribe(response => {
      if (response.Ok) {
        this.news = response.Obj;
        this.news = this.news.slice(0, 3);
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  firstLogin() {
    if (sessionStorage.getItem('FirstLogin') !== 'false') {
      Swal.mixin({
        input: 'password',
        inputValidator: (value) => {
          this.tempPw1 = value;
          return !value && this.translation.YouHaveToEnterAPassword;
        },
        confirmButtonColor: '#CC0000',
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: true,
        reverseButtons: true,
        confirmButtonText: this.translation.Next + ' &rarr;',
        progressSteps: ['1', '2']
      }).queue([
        {
          title: this.translation.Welcome,
          text: this.translation.PleaseChangeYourPassword,
          inputValidator: (value) => {
            this.tempPw1 = value;
            return !value && this.translation.YouHaveToEnterAPassword;
          },
          currentProgressStep: '0'
        },
        {
          title: this.translation.Welcome,
          text: this.translation.PleaseRepeatYourNewPassword,
          inputValidator: (value) => {
            this.tempPw2 = value;
            if (this.tempPw1 !== this.tempPw2) { return this.translation.RepeatPasswordNotCorrectMessage; }
            return !value && this.translation.YouHaveToRepeatTheNewPassword;
          },
          currentProgressStep: '1'
        }
      ]).then((firstLoginResult: any) => {
        if (firstLoginResult.value) {
          this.userService.getUserById(+sessionStorage.getItem('UserId')).subscribe(responseUser => {
            if (responseUser.Ok) {
              this.changePasswordService.updatePasswordWithoutToken(responseUser.Obj.UserId, this.tempPw2).subscribe(responsePassword => {
                if (responsePassword.Ok) {
                  if (responsePassword.Obj) {
                    this.userService.updateUserFirstLogin(+sessionStorage.getItem('UserId')).subscribe(responseFirstLogin => {
                      if (responseFirstLogin.Ok) {
                        if (responseFirstLogin.Obj) {
                          sessionStorage.setItem('FirstLogin', responseFirstLogin.Obj.FirstLogin ? 'true' : 'false');
                          this.termsAndConditionsRead();
                          Swal.fire({title: this.translation.PasswordChanged, icon: 'success', confirmButtonColor: '#CC0000'});
                        }
                      } else if (responseFirstLogin.Msg === 'Internal Server Error') { console.log(responseFirstLogin.Ex); }
                      if (responseFirstLogin.Msg) { this.toast.fire({title: responseFirstLogin.Msg, icon: responseFirstLogin.Ok ? 'success' : 'error'}); }
                    }, error => { this.toast.fire(this.translation.InternalServerError); });
                  } else {
                    this.toast.fire(this.translation.InternalServerError);
                  }
                } else if (responsePassword.Msg === 'Internal Server Error') { console.log(responsePassword.Ex); }
                if (responsePassword.Msg) { this.toast.fire({title: responsePassword.Msg, icon: responsePassword.Ok ? 'success' : 'error'}); }
              }, error => { this.toast.fire(this.translation.InternalServerError); });
            } else if (responseUser.Msg === 'Internal Server Error') { console.log(responseUser.Ex); }
            if (responseUser.Msg) { this.toast.fire({title: responseUser.Msg, icon: responseUser.Ok ? 'success' : 'error'}); }
          }, error => { this.toast.fire(this.translation.InternalServerError); });
        }
      });
    }
  }

  termsAndConditionsRead() {
    if (sessionStorage.getItem('TermsAndConditionRead') !== 'true') {
      Swal.fire({
        html: this.getTermsAndConditions(),
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: false,
        allowOutsideClick: false,
        confirmButtonText: this.translation.Accept,
        cancelButtonText: this.translation.Reject,
        width: 1100,
      }).then((termsResult) => {
        if (termsResult.value) {
          this.userService.updateUserTermsAndConditionRead(+sessionStorage.getItem('UserId')).subscribe(response => {
            if (response.Ok) {
              if (response.Obj) {
                sessionStorage.setItem('TermsAndConditionRead', response.Obj.TermsAndConditionRead ? 'true' : 'false');
                this.firstLogin();
              } else {
                Swal.fire(this.translation.Error, this.translation.Various, 'error');
              }
            } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
            if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
          }, error => { this.toast.fire(this.translation.InternalServerError); });
        } else if (termsResult.dismiss) {
          sessionStorage.clear();
          this.router.navigate(['/login']).then();
        }
      });
    }
  }

  getTermsAndConditions() {
    return '<div style="text-align: left">' +
      '<h2 style="padding-bottom: 40px;">' + this.translation.AgbHeaderPart1 + ' ' + this.translation.AgbHeaderPart2 + '</h2>' +
      '<h3>' + this.translation.Agb1Header + '</h3>' +
      '<p>' + this.translation.Agb1Line1 + '</p>' +
      '<p>' + this.translation.Agb1Line2 + '</p>' +
      '<h3>' + this.translation.Agb2Header + '</h3>' +
      '<p>' + this.translation.Agb2Line1 + '</p>' +
      '<h3>' + this.translation.Agb3Header + '</h3>' +
      '<p>' + this.translation.Agb3Line1 + '</p>' +
      '<h3>' + this.translation.Agb4Header + '</h3>' +
      '<p>' + this.translation.Agb4Line1 + '</p>' +
      '<p>' + this.translation.Agb4Line2 + '</p>' +
      '<p>' + this.translation.Agb4Line3 + '</p>' +
      '<p>' + this.translation.Agb4Line4 + '</p>' +
      '<h4>' + this.translation.Agb41Header + '</h4>' +
      '<p>' + this.translation.Agb41Line1 + '</p>' +
      '<p>' + this.translation.Agb41Line2 + '</p>' +
      '<h4>' + this.translation.Agb42Header + '</h4>' +
      '<p>' + this.translation.Agb42Line1 + '</p>' +
      '<h4>' + this.translation.Agb43Header + '</h4>' +
      '<p>' + this.translation.Agb43Line1 + '</p>' +
      '<h3>' + this.translation.Agb5Header + '</h3>' +
      '<p>' + this.translation.Agb5Line1 + '</p>' +
      '<h4>' + this.translation.Agb51Header + '</h4>' +
      '<p>' + this.translation.Agb51Line1 + '</p>' +
      '<p>' + this.translation.Agb51Line2 + '</p>' +
      '<h4>' + this.translation.Agb52Header + '</h4>' +
      '<p>' + this.translation.Agb52Line1 + '</p>' +
      '<h3>' + this.translation.Agb6Header + '</h3>' +
      '<p>' + this.translation.Agb6Line1 + '</p>' +
      '<h3>' + this.translation.Agb7Header + '</h3>' +
      '<p>' + this.translation.Agb7Line1 + '</p>' +
      '<h3>' + this.translation.Agb8Header + '</h3>' +
      '<p>' + this.translation.Agb8Line1 + '</p>' +
      '<p>' + this.translation.Agb8Line2 + '</p>' +
      '</div>';
  }

  openNewsDialog(newsitem: News) {
    Swal.fire({
      title: newsitem.Title,
      html: newsitem.Content,
      confirmButtonColor: '#CC0000',
      width: 1000,
      customClass: {
        content: 'customContent'
      },
    });
  }
}
